import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./SideMenu.scss";
import { getCounts } from "../../api/apiServiceFetch";
import { useAuth } from "../../contexts/auth";

// User-to-user chat visibility is limited to specific admins.
const CHAT_MODERATION_ADMIN_IDS = [1, 5];

const SideMenu = ({ isMenuOpen, setIsMenuOpen }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { userBase } = useAuth();
	const [counts, setCounts] = useState({});

	const canModerateChats = CHAT_MODERATION_ADMIN_IDS.includes(
		Number(userBase?.adminUserId),
	);

	const fetchCounts = useCallback(async () => {
		try {
			const countsData = await getCounts();
			setCounts(countsData ?? {});
		} catch (error) {
			console.error("Error fetching counts:", error);
		}
	}, []);

	useEffect(() => {
		fetchCounts();
	}, [fetchCounts]);

	const handleNavigation = (path) => {
		navigate(path);
		fetchCounts();
		setIsMenuOpen(false);
	};

	const items = [
		{ path: "/", label: "Домой" },
		{ path: "/analytics", label: "Аналитика" },
		{ path: "/all-profiles", label: "Все профили", count: counts.allUsers },
		{ path: "/new-profiles", label: "Новые профили", count: counts.newUsers, tone: "new" },
		{ path: "/edit-profiles", label: "Редакт. профили", count: counts.editsUsers, tone: "new" },
		{ path: "/fail-profiles", label: "Фэйл профили", count: counts.failedUsers },
		{ path: "/freezed-profiles", label: "Заморозки", count: counts.freezedUsers },
		{ path: "/reports", label: "Жалобы", count: counts.allReports, extraCount: counts.newReports },
		{ path: "/delete-requests", label: "Запросы на удаление" },
		{ path: "/support-messages", label: "Сообщения в поддержку", extraCount: counts.newSupportMessages },
		...(canModerateChats
			? [{ path: "/user-chats", label: "Чаты пользователей" }]
			: []),
		{ path: "/dell-profiles", label: "Удаленные профили", count: counts.delUsers },
		{ path: "/orders", label: "Тарифы" },
		{ path: "/date-cards", label: "Карточки свиданий" },
		{ path: "/game-cupid", label: "Игра Cupid" },
		{ path: "/deletion-messages", label: "Сообщения удаления" },
		{ path: "/broadcasts", label: "Рассылки" },
		{ path: "/blocked-profiles", label: "Заблокированные", count: counts.blockedUsers, tone: "info" },
		{ path: "/settings", label: "Настройки" },
		{ path: "/documents", label: "Документы" },
		{ path: "/family-stories", label: "Семьи в Jerm" },
		{ path: "/auth-providers", label: "Входы Google и Apple" },
		{ path: "/google-api-keys", label: "Ключи Google" },
	];

	const renderBadge = (value, tone) => {
		if (value === undefined || value === null) return null;
		const toneClass = tone && Number(value) > 0 ? ` side-menu__badge--${tone}` : "";
		return <span className={`side-menu__badge${toneClass}`}>{value}</span>;
	};

	return (
		<nav className={`side-menu ${isMenuOpen ? "open" : ""}`}>
			<ul>
				{items.map((item) => (
					<li
						key={item.path}
						className={location.pathname === item.path ? "active" : ""}
						onClick={() => handleNavigation(item.path)}
					>
						<span className="side-menu__label">{item.label}</span>
						{renderBadge(item.count, item.tone)}
						{item.extraCount > 0 && renderBadge(item.extraCount, "alert")}
					</li>
				))}
			</ul>
		</nav>
	);
};

export default SideMenu;
